var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-m-loader"},[_c('div',{staticClass:"c-m-loader__icon-wrapper"},[_c('div',{staticClass:"c-m-loader__icon"},[_c('icon',{attrs:{"icon":'spinner'}})],1)]),_vm._v(" "),(_vm.heading)?_c('div',{staticClass:"c-m-loader__content"},[_c('p',{staticClass:"c-m-loader__heading"},[_vm._v(_vm._s(_vm.heading))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-515f097c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/molecules/MoleculeLoader.vue
// module id = 1161
// module chunks = 0